import { Tables } from "database.types";
import { fetchApi } from "./base";
import { JustTcgCard, JustTcgVariant } from "./types";

export type CatalogCard = Tables<"cards"> & {
  language: "english" | "japanese" | "chinese";
  catalog_source: string;
  source_image_url: string | null;
};

export async function getCards(
  params: {
    query?: string;
    pricing?: "false";
    page?: number;
    perPage?: number;
    sets?: string[];
    language?: "english" | "japanese" | "chinese" | undefined;
    condition?: string;
    sortBy?:
      | "name"
      | "created_at"
      | "updated_at"
      | "rarity"
      | "number"
      | "main_price";
    sortDir?: "asc" | "desc";
  },
  options: { signal?: AbortSignal } = {},
) {
  // Keep the deadline active when filter changes also supply a cancel signal.
  const controller = new AbortController();
  const abort = () => controller.abort();
  const timeout = setTimeout(abort, 30000);
  if (options.signal?.aborted) abort();
  else options.signal?.addEventListener("abort", abort, { once: true });
  try {
    return await fetchApi<{
      success: boolean;
      data: Array<CatalogCard & { set: Tables<"sets">; game: Tables<"games"> }>;
      page: number;
      perPage: number;
      total: number;
      totalPages: number;
    }>(`/api/cards/search`, {
      method: "GET",
      params,
      retry: 0,
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timeout);
    options.signal?.removeEventListener("abort", abort);
  }
}

export function getCardByTcgPlayerId(id: string) {
  return fetchApi<{
    success: boolean;
    data: CatalogCard;
  }>(`/api/cards/tcgplayer/${id}`, {
    method: "GET",
  });
}

export function getCardById(id: number) {
  return fetchApi<{
    success: boolean;
    data: CatalogCard & {
      set: Tables<"sets">;
      game: Tables<"games">;
    };
  }>(`/api/cards/${id}`, {
    method: "GET",
  });
}
